import { Outlet, useNavigation, useRevalidator } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { useIntercom } from 'react-use-intercom';
import { useEffect, useRef } from 'react';
import MainMenu from './mainMenu';
import { LoadingSpinner, SpinnerSizeValues } from '../../shared/components';
import useAuth from '../../utils/auth';

export default function AppLayout() {
  const navigation = useNavigation();
  const revalidator = useRevalidator();
  const isNavigating = navigation.state === 'loading' || revalidator.state === 'loading';
  const { boot, update } = useIntercom();
  const authUser = useAuth();
  const { branch } = authUser.hmrcDataToggle;
  const loadedBranch = useRef(branch);

  // Switching HMRC data changes the branch the page's data comes from: rerun the route loaders here,
  // and the key on Outlet remounts the page so components that fetch for themselves fetch again
  useEffect(() => {
    if (loadedBranch.current === branch) {
      return;
    }
    loadedBranch.current = branch;
    void revalidator.revalidate();
  }, [branch, revalidator]);

  useEffect(() => {
    boot();
  }, [boot]);

  useEffect(() => {
    update({
      email: authUser.email,
      name: `${authUser.firstName} ${authUser.lastName}`,
      userId: `LIFT:${authUser.email}`,
    });
  }, [update, authUser]);

  return (
    <div className="relative flex h-screen w-full ">
      <div className="bg-transparent flex ">
        <MainMenu />
      </div>
      <div className="relative flex grow w-full min-w-0 border-l border-pipgrey-light">
        <main className="flex grow w-full overflow-auto bg-pipgrey-background">
          <Outlet key={branch} />
          <ToastContainer />
        </main>
        {isNavigating && (
          <output id="navigation-overlay" className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-2 bg-white">
            <LoadingSpinner size={SpinnerSizeValues.Large} />
            <p>Loading...</p>
          </output>
        )}
      </div>
    </div>
  );
}
